import axios from "./axios";
import * as Requests from "./requests";

export const getStoreInfoAPI = (token: string, id: string) => {
  return axios.get(Requests.getStoreInfoUrl(id), {
    headers: {
      token,
    },
    baseURL: process.env.REACT_APP_PICKUP_ENDPOINT,
  });
};
